import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import {
  CalendarToday,
  Close,
  Person,
  DateRange,
  AccessTime,
} from "@mui/icons-material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useNavigate } from "react-router-dom";
export const TableView: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();

  const [selectedTime, setSelectedTime] = useState<Date | null>(new Date());

  const handleTimeChange = (newTime: Date | null) => {
    setSelectedTime(newTime);
  };

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Grid
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f0f0f0",
        }}
      >
        {/* Header */}

        {/* Main Content */}
        <Grid container sx={{ flexGrow: 1 }}>
          {/* Left Panel */}
          <Grid
            item
            xs={8}
            sx={{ backgroundColor: "#1565c0", position: "relative" }}
          >
            <Paper
              sx={{
                top: 10,
                left: 10,
                position: "absolute",
                width: 100,
                height: 70,
                backgroundColor: "cyan",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography>1</Typography>
            </Paper>
          </Grid>

          {/* Right Panel */}
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "#e0e0e0",
              padding: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Date Picker with Close Button */}
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography>Select Date</Typography>
              <TextField
                variant="outlined"
                size="small"
                type="date"
                defaultValue="2024-10-09"
                sx={{ width: "60%" }}
              />
              <IconButton>
                <WSIcons.CloseIcon
                  sx={{ backgroundColor: "red", color: "white" }}
                  onClick={() => handleClick("/reservationlist")}
                />
              </IconButton>
            </Grid>

            <Divider sx={{ mb: 2 }} />

            {/* Clock Display */}
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: "3.5rem",
                  fontWeight: "bold",
                  color: "#2e7d32",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {selectedTime?.getHours().toString().padStart(2, "0")} :
                {selectedTime?.getMinutes().toString().padStart(2, "0")}
                <Typography variant="h6" sx={{ ml: 1 }}>
                  {selectedTime && selectedTime.getHours() >= 12 ? "PM" : "AM"}
                </Typography>
              </Typography>

              {/* Interactive Time Picker */}
              <TimePicker
                ampm
                openTo="hours"
                views={["hours", "minutes"]}
                value={selectedTime}
                onChange={handleTimeChange}
                slotProps={{
                  textField: { sx: { mt: 2 } },
                }}
              />
            </Grid>

            {/* Bottom Buttons */}
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-around",
                mt: "auto",
                paddingTop: 2,
              }}
            >
              <Button color="success">
                <WSIcons.EditNoteIcon />
                KOT
              </Button>
              <Button color="success">
                <WSIcons.ReceiptIcon />
                Receipt
              </Button>
              <Button color="success">
                <WSIcons.Reservation />
                Reservation
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            backgroundColor: "#333",
            padding: ".5rem",
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Grid item>
            <WSIcons.GTranslateIcon sx={{ color: "white" }} />
          </Grid>

          <IconButton>
            <WSIcons.KeyboardArrowLeftIcon sx={{ color: "white" }} />
          </IconButton>
          <Button variant="contained" color="success">
            Main
          </Button>
          <IconButton>
            <WSIcons.ChevronRightIcon sx={{ color: "white" }} />
          </IconButton>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
});
